module.exports = __webpack_public_path__ + "img/LOGO.fe0d6588.png";